import React from 'react';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSwatchbook } from '@fortawesome/pro-light-svg-icons';

import card from '../components/RoomOptionTwoTierList/RoomOptionCards.module.scss';
import { StyleGroupCard } from './StyleGroupCard';
import { StyleSelectionModal } from './StyleSelectionModal';
import { useStyleWalkthrough } from './useStyleWalkthrough';

/**
 * The room's Styles section for the centered card layout (immersive, no visualization). Mirrors
 * `RoomStyleSection` (used by the list layouts) but renders each applicable style group as a
 * two-column card in a responsive grid. Clicking a card opens the style-selection modal. Renders
 * nothing when no style group applies to the room.
 *
 * On entering a room whose styles aren't all picked yet, the modal opens automatically and walks the
 * user through the unpicked groups in sequence (see `useStyleWalkthrough`).
 */
export const RoomStyleCardSection: React.FC = () => {
    const { groups, walkGroups, openGroup, close } = useStyleWalkthrough();

    if (groups.length === 0) {
        return null;
    }

    return (
        <section className={card.section}>
            <div className={card.sectionHeader}>
                <span className={card.sectionLabel}>
                    <FontAwesomeIcon className={card.sectionIcon} icon={faSwatchbook} />
                    <span className={card.sectionName}>
                        <Trans>Styles</Trans>
                    </span>
                </span>
            </div>
            <div className={card.grid}>
                {groups.map((group) => (
                    <StyleGroupCard key={`style-${group.id}`} styleGroup={group} onClick={() => openGroup(group)} />
                ))}
            </div>
            {walkGroups && walkGroups.length > 0 && <StyleSelectionModal groups={walkGroups} onClose={close} />}
        </section>
    );
};
